import {imgverify, loginquick, safloginquick, safsmsverify, smsverify} from "../api";

const ERROR = {
	WRONG_PHONE: 1, // 手机号不正确
	SMS_SENDING: 2, // 正在发送验证码
	SMS_WAITING: 3, // 发送验证码太频繁
	IMAGECODE: 4, // 需要图片验证码
	EMPTY_PHONE: 5, // 手机号码不能为空
	EMPTY_SMS: 6, // 请输入短信验证码
	EMPTY_IMAGECODE: 7, // 请输入图片验证码
	WRONG_SMSCODE: 8, // 请输入正确的验证码
	WRONG_IMAGECODE: 9, // 请输入正确的图片验证码
};

export default class PhoneLogin {
	/**
	 *
	 * @param {object} options
	 * @param {number} [options.width=90]
	 * @param {number} [options.height=40]
	 * @param {number} [options.fontsize=16]
	 * @param {number} [options.length=4]
	 */
	constructor(options) {
		options = Object.assign({}, options);
		this.imageOptions = {
			width: options.width || 90,
			height: options.height || 40,
			fontsize: options.fontsize || 16,
			length: options.length || 4,
		};
		this.options = options;
		this.phoneNumber = ""; // 用户输入的手机号
		this.smsCode = ""; // 用户输入的验证码
		this.imageCode = ""; // 用户输入的图形验证码
		this.smsTimeout = 0; // 多少秒之后可以再次发验证码
		this.smsLoading = false; // 正在发送验证码
		this.imageURL = ""; // 图形验证码链接
		this.errorCode = ""; // 错误信息
	}
	/**
	 * 是否正常手机号
	 * @param {string} [phone]
	 * @returns
	 */
	isPhone(phone) {
		// console.log(/^([1-9]{1,3}-)?1[3-9][0-9]{9}$/.test(phone == null ? this.phoneNumber : phone));
		return /^([1-9]{1,3}-)?1[3-9][0-9]{9}$/.test(phone == null ? this.phoneNumber : phone);
	}
	issmsCode(code) {
		return /^[0-9]*$/.test(code == null ? this.smsCode : code);
	}
	isimgCode(code) {
		return /[^\w\/]/gi.test(code == null ? this.imageCode : code);
	}
	/**
	 * 设置错误码
	 * @param {number} code
	 * @returns
	 */
	onError(code) {
		this.errorCode = code;
		return code;
	}
	/**
	 * 用户输入手机号
	 * @param {string} str
	 */
	onChangePhoneNumber(str) {
		if (str.length > 11) str = str.slice(0, 11);
		this.phoneNumber = str;
		if (this.imageURL) {
			this.imageURL = "";
		}
	}
	onBlurPhone(str) {
		if (str == "") return this.onError(ERROR.EMPTY_PHONE);
		if (this.isPhone(str)) {
			return this.onError(0);
		} else {
			return this.onError(ERROR.WRONG_PHONE);
		}
	}
	/**
	 * 用户输入短信验证码
	 * @param {string} code
	 */
	onChangeSmsCode(code) {
		if (code.length != 4) {
			this.smsCode = code.slice(0, 4);
		} else {
			this.smsCode = code;
		}
	}
	onBlurSms(code) {
		// debugger;
		if (code.length == 0) {
			// console.log("-----------");
			return this.onError(ERROR.EMPTY_SMS);
		}
		if (!this.issmsCode(code)) {
			this.smsCode = code;
			return this.onError(ERROR.WRONG_SMSCODE);
		} else {
			return this.onError(0);
		}
	}
	/**
	 * 用户输入图片验证码
	 * @param {string} code
	 */
	onChangeImageCode(code) {
		// if (code.length != this.imageOptions.length) {
		// 	this.imageCode = code.slice(0, this.imageOptions.length);
		// }
		if (code.length != 4) {
			this.imageCode = code.slice(0, 4);
		} else {
			this.imageCode = code;
		}
	}
	onBlurImgCode(code) {
		if (code.length == 0) {
			return this.onError(ERROR.EMPTY_IMAGECODE);
		} else if (this.isimgCode(code)) {
			this.imageCode = code;
			return this.onError(ERROR.WRONG_IMAGECODE);
		} else {
			return this.onError(0);
		}
	}
	/**
	 * 发送验证码
	 * @return {Promise<number>} 出错时返回错误码
	 */
	sendSms() {
		// this.onBlurSms(this.phoneNumber);
		// console.log("aaaaaa");
		if (this.phoneNumber == "") return this.onError(ERROR.EMPTY_PHONE);
		if (!this.isPhone()) return this.onError(ERROR.WRONG_PHONE);
		if (this.smsLoading) return this.onError(ERROR.SMS_SENDING);
		if (this.smsTimeout) return this.onError(ERROR.SMS_WAITING);
		this.smsLoading = true;
		if (this.imageURL) {
			// console.log("smsverify", this.imageCode, this.phoneNumber);
			return smsverify({
				account: this.phoneNumber,
				verifytype: "quicklogin",
				imgcode: this.imageCode,
			})
				.then((res) => {
					this.smsTimeout = 60;
					var handle = setInterval(() => {
						if (!--this.smsTimeout) clearInterval(handle);
					}, 1e3);
					return 0;
				})
				.catch((err) => {
					console.error("带图获取验证码失败", err);
					this.onError(9);
				})
				.finally(() => (this.smsLoading = false));
		}
		return safsmsverify({
			account: this.phoneNumber,
			verifytype: "quicklogin",
		}).then(
			(res) => {
				this.smsTimeout = 60;
				var handle = setInterval(() => {
					if (!--this.smsTimeout) clearInterval(handle);
				}, 1e3);
				this.smsLoading = false;
				return 0;
			},
			() => {
				this.smsLoading = false;
				return this.getImageCode().then(() => ERROR.IMAGECODE);
			}
		);
	}
	/**
	 * 获取/刷新图片验证码
	 * @param {ImageCodeOptions} [options]
	 */
	getImageCode(options) {
		if (options) this.imageOptions = Object.assign({}, this.imageOptions, options);
		return imgverify(this.imageOptions).then((url) => {
			this.imageURL = url;
			console.log("imageURL", this.imageURL);
		});
	}
	/**
	 * 执行登录操作
	 */
	submit() {
		if (!this.phoneNumber) {
			return this.onError(ERROR.EMPTY_PHONE);
		}
		if (!this.smsCode) {
			return this.onError(ERROR.EMPTY_SMS);
		}
		if (!this.isPhone()) {
			return this.onError(ERROR.WRONG_PHONE);
		}
		if (this.imageURL && !this.imageCode) {
			return this.onError(ERROR.EMPTY_IMAGECODE);
		}
		if (this.imageURL) {
			return loginquick({
				account: this.phoneNumber,
				smscode: this.smsCode,
				imgcode: this.imageCode,
				showvip: 1,
			});
		}
		return safloginquick({
			account: this.phoneNumber,
			smscode: this.smsCode,
			showvip: 1,
		});
	}
}
